var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgTrashBin = function SvgTrashBin(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 19
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M.818 4.75A.805.805 0 0 1 0 3.958c0-.403.312-.736.716-.785l.102-.006h4.091V1.583C4.909.709 5.642 0 6.545 0h4.91c.903 0 1.636.709 1.636 1.583v1.584h4.09c.453 0 .819.354.819.791a.802.802 0 0 1-.716.786l-.102.006h-.818v12.667c0 .828-.658 1.508-1.496 1.577l-.14.006H3.273c-.856 0-1.559-.636-1.63-1.447l-.007-.136V4.75H.818zm13.91 0H3.273v12.667h11.454V4.75zM8.795 7.917c.418 0 .762.302.812.692l.007.1v4.75c0 .437-.367.791-.819.791a.81.81 0 0 1-.811-.692l-.007-.1v-4.75c0-.437.367-.791.818-.791zM5.523 9.104a.81.81 0 0 1 .812.693l.006.099v2.375a.805.805 0 0 1-.818.791.81.81 0 0 1-.812-.692l-.006-.1V9.896c0-.437.366-.792.818-.792zm6.545 0a.81.81 0 0 1 .812.693l.006.099v2.375a.805.805 0 0 1-.818.791.81.81 0 0 1-.812-.692l-.006-.1V9.896c0-.437.366-.792.818-.792zm-.613-7.52h-4.91v1.583h4.91V1.583z",
    fill: "#484848",
    fillRule: "nonzero"
  })));
};

export default SvgTrashBin;